import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetailPage, serviceDetailHead } from "@/components/site/ServiceDetailPage";
import { serviceDetails } from "@/lib/service-details";

const service = serviceDetails.find((s) => s.slug === "accounts-receivable")!;

export const Route = createFileRoute("/services/accounts-receivable")({
  head: () => serviceDetailHead(service),
  component: () => <ServiceDetailPage service={service} />,
});
